import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Главная")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolbarItem = _resolveComponent("ToolbarItem")!

  return (_openBlock(), _createBlock(_component_ToolbarItem, {
    class: _normalizeClass(_ctx.$style.toolbarItemHome),
    as: "router-link",
    icon: "/icons/home.svg",
    to: { name: 'index' }
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _hoisted_1
      ])
    ]),
    _: 3
  }, 8, ["class"]))
}